import Form from 'src/utils/Form.js'

class Category extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get('helps/categories/' + this.id + '/edit').then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  fill(data) {
    this.originalData = data
    for (let field in data) {
        this[field] = data[field]
    }
  }

  static all(parameters, then) {
    return new Form().get('helps/categories' + '?' + parameters).then(then)
  }

  create(then) {
    return super.post(`helps/categories`).then(then);
  }

  update(then) {
    let fd = new FormData();
    for (let field in this.data()) {
        if(typeof this[field] !== 'undefined' ) {
            if(field === 'images') {
                for( var i = 0; i < this[field].length; i++ ){
                    if(this[field][i].id === undefined)
                        fd.append(field+'[' + i + ']', this[field][i]);
                }
            } else {
                fd.append(field, this[field])
            }
        }
    }
    fd.append('_method', 'PATCH');
    return super.post('helps/categories/' + this.id, fd).then(data => {
        this.originalData = data
        for (let field in this.originalData) {
            if(field === 'images') {
                this[field] = []
            } else {
                this[field] = data[field]
            }
        }
        then(data)
      })
  }


  uploadImage(file, then) {
    let fd = new FormData();
    fd.append('image', file);
    return super.post('helps/categories/upload', fd).then(then)
  }

  destroy(then) {
    return super.delete('helps/categories/' + this.id).then(then)
  }
}

export default Category
